module.exports = __webpack_public_path__ + "static/media/art1.0406dd87.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/art1.png
// module id = 875
// module chunks = 0